import React from "react";
import ReactDOM from "react-dom/client"; 
import { BrowserRouter } from "react-router-dom";
import App from "../src/App";


const baseHref =
  window.location.hostname === "localhost"
    ? "/" 
    : "/2025/labs/bottrop/students/annasophia-brokuf"; 

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={baseHref}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
